import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Observable, map } from 'rxjs';
import { UserService } from 'src/app/modules/services/user.service';
import { errorDescription, url } from 'src/app/modules/util/constants';

@Component({
  selector: 'app-edit-username',
  templateUrl: './edit-username.component.html',
  styleUrls: ['./edit-username.component.css']
})
export class EditUsernameComponent {

  constructor(private router: Router, private fb: FormBuilder, private userService: UserService, private messageService: MessageService) {
    this.usernameForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('[0-9]+')],
      UsernameValidator.createValidator(this.userService, this.messageService)]});
  }

  @Input() displayDialog: boolean = false;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Input() userName: string = '';
  @Input() urlId: string = '';
  usernameForm: FormGroup;

  changeUsername() {
    this.userService.changeUsername(this.userName, this.usernameForm.value['username'], this.urlId).subscribe({
      next: response => {
        if (response.status === 'success') {
          this.messageService.add({detail: 'Cambio de número de teléfono correcto', severity: 'success'});
          this.closeDialog();
        } else {
          this.messageService.add({detail: 'No fue posible cambiar el número de teléfono', severity: 'error'});
        }
      },
      error: error => {
        this.messageService.add({severity: 'error', detail: errorDescription[error.error.error]});
        this.router.navigate([url['login']]);
      }
    });

  }

  closeDialog() {
    this.displayDialog = false;
    this.usernameForm.markAsPristine();
    this.usernameForm.get('username')?.patchValue('');
    this.displayDialogChange.emit(this.displayDialog);
  }
}

class UsernameValidator {
  static createValidator(userService: UserService, messageService: MessageService): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return userService.checkUser(control.value).pipe(
        map((response) => {
          let exists: boolean = Boolean(response.data);
          if (exists) {
            messageService.clear();
            messageService.add({
              key: 'user',
              severity: 'error',
              detail: 'Este número ya se encuentra registrado'
            });
          } else {
            messageService.clear();
          }
          return exists ? { usernameAlreadyExists: true } : null
        }
        )  
      );
    };
  }
}